export class RimReportRequest {
    caseCode = '';
    rimHeaderIds: number[] = [];
}
